module.exports = __webpack_public_path__ + "img/empty-data.2711032d.svg";